import { OpenNewTabTargetType } from '@voltmoney/types';
import SharedPropsService from '../../SharedPropsService';
import { onShareAdvisory, openAdvisorLinkWhatsApp, openAdvisorLinkWhatsAppOnPhone, openAdvisoryLinkTelegram, } from '../../configs/utils';
import { InviteAndEarnLink } from '../../configs/constants';
import { ROUTE } from '../../routes';
import { ColorTokens, WIDGET } from '@voltmoney/schema';
import { rebuildReferredPartnerMobileCardBuilder, ReferredPartnerTableBuilder, searchObject, sideBarNavigate } from "../dashboard/utils";
import { rebuildReferredPartnerTable } from "../utils";
let tableSearchString_RP = '';
let ReferredPartnerData = [];
let newCounter = 1;
let array;
let appendArray = [];
let appendDefinedValues = [];
export const onSearchReferredPartner = async (action, _datastore, standardUtilities) => {
    tableSearchString_RP = action.payload.value;
    const linkedPartnersData = await SharedPropsService.getLinkedPartnersList();
    if (tableSearchString_RP === "") {
        await standardUtilities.setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "referredPartnerTable", {
            titleMap: {
                ...ReferredPartnerTableBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...ReferredPartnerTableBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...ReferredPartnerTableBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await standardUtilities.appendWidgets(ROUTE.PLATFORM_LINKED_PARTNERS, {
            ...ReferredPartnerTableBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === 1) {
            await standardUtilities.setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "referredPartnerTable", {
                titleMap: {
                    ...ReferredPartnerTableBuilder(linkedPartnersData.slice(0, 50)).Title_MAP,
                },
                titleConfig: {
                    ...ReferredPartnerTableBuilder(linkedPartnersData.slice(0, 50))
                        .TITLE_CONFIG,
                },
                widgetData: {
                    ...ReferredPartnerTableBuilder(linkedPartnersData.slice(0, 50)).DATA,
                },
                data: linkedPartnersData.slice(0, 50),
            });
            await standardUtilities.appendWidgets(ROUTE.PLATFORM_LINKED_PARTNERS, {
                ...ReferredPartnerTableBuilder(linkedPartnersData.slice(0, 50)).DATA_STORE,
            }, [
                {
                    id: "referredPartnerTableStack11", type: WIDGET.STACK
                }
            ], "spaceStack");
        }
    }
    else {
        ReferredPartnerData = linkedPartnersData.filter(data => {
            const results = searchObject(data, tableSearchString_RP);
            if (results && results.length > 0) {
                return true;
            }
            else {
                return false;
            }
        });
        if (action?.payload?.widgetId === 'referredPartnerMobSearchInput') {
            await rebuildReferredPartnerMobileCardBuilder(standardUtilities, ReferredPartnerData);
        }
        else {
            await rebuildReferredPartnerTable(standardUtilities, ReferredPartnerData);
        }
    }
};
export const appendCounter = async (action, _datastore, { setDatastore, appendWidgets }) => {
    array = action.payload.array;
    const totalNoOfPages = action.payload.totalNoOfPages;
    await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "referredPartnerTableStack1", {
        loading: false
    });
    if (newCounter !== totalNoOfPages) {
        newCounter = newCounter + 1;
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "nextText", {
            color: ColorTokens.Grey_Night
        });
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "rightIcon", {
            color: ColorTokens.Grey_Night
        });
        if (newCounter > 1) {
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "previousText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "leftIcon", {
                color: ColorTokens.Grey_Night
            });
        }
        else {
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "previousText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "leftIcon", {
                color: ColorTokens.Grey_Charcoal
            });
        }
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "currentPageNumber", {
            label: `Page ${newCounter}`,
        });
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "spaceStack", {
            hide: false
        });
        const pageNumber = newCounter;
        const valuesToShowPerPage = 50;
        const startValue = (pageNumber - 1) * valuesToShowPerPage + 1;
        const endValue = pageNumber * valuesToShowPerPage;
        appendArray = [];
        for (let i = startValue; i <= endValue; i++) {
            appendArray.push(array[i]);
        }
        appendDefinedValues = appendArray.filter((value) => value !== undefined);
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "referredPartnerTable", {
            titleMap: {
                ...ReferredPartnerTableBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...ReferredPartnerTableBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...ReferredPartnerTableBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await appendWidgets(ROUTE.PLATFORM_LINKED_PARTNERS, {
            ...ReferredPartnerTableBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === totalNoOfPages) {
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "nextText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "rightIcon", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "previousText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "leftIcon", {
                color: ColorTokens.Grey_Night
            });
        }
    }
    else {
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "nextText", {
            color: ColorTokens.Grey_Charcoal
        });
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "rightIcon", {
            color: ColorTokens.Grey_Charcoal
        });
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "previousText", {
            color: ColorTokens.Grey_Night
        });
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "leftIcon", {
            color: ColorTokens.Grey_Night
        });
    }
};
export const minusCounter = async (action, _datastore, { setDatastore, appendWidgets }) => {
    if (newCounter > 1) {
        newCounter = newCounter - 1;
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "currentPageNumber", {
            label: `Page ${newCounter}`,
        });
        const pageNumber = newCounter;
        const valuesToShowPerPage = 50;
        const startValue = (pageNumber - 1) * valuesToShowPerPage + 1;
        const endValue = pageNumber * valuesToShowPerPage;
        appendArray = [];
        for (let i = startValue; i <= endValue; i++) {
            appendArray.push(array[i]);
        }
        appendDefinedValues = appendArray.filter((value) => value !== undefined);
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "referredPartnerTable", {
            titleMap: {
                ...ReferredPartnerTableBuilder(appendDefinedValues).Title_MAP,
            },
            titleConfig: {
                ...ReferredPartnerTableBuilder(appendDefinedValues)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...ReferredPartnerTableBuilder(appendDefinedValues).DATA,
            },
            data: appendDefinedValues,
        });
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "spaceStack", {
            hide: false
        });
        await appendWidgets(ROUTE.PLATFORM_LINKED_PARTNERS, {
            ...ReferredPartnerTableBuilder(appendDefinedValues).DATA_STORE,
        }, [
            {
                id: "referredPartnerTableStack11", type: WIDGET.STACK
            }
        ], "spaceStack");
        if (newCounter === 1) {
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "previousText", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "leftIcon", {
                color: ColorTokens.Grey_Charcoal
            });
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "nextText", {
                color: ColorTokens.Grey_Night
            });
            await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, "rightIcon", {
                color: ColorTokens.Grey_Night
            });
        }
    }
};
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    console.warn('**** onChangeTab leads Action Triggered ****', action);
    await sideBarNavigate(standardUtilities, action);
};
export const onCtaWhatsApp = async (action, _datastore, { instrumentTrack }) => {
    instrumentTrack("REFER_MFD_INITIATED", {
        "type": "WhatsApp"
    });
    console.warn('**** onCtaWhatsApp leads Action Triggered ****', action);
    const advisoryLink = action.payload.advisorLink;
    const partnerName = action.payload.partnerName;
    const partnerInterestRate = await SharedPropsService.getFirebaseConfig().partner_interest_rate;
    if (action.payload.value === 'WEB') {
        openAdvisorLinkWhatsApp(`${partnerInterestRate}`, advisoryLink, partnerName);
    }
    else {
        openAdvisorLinkWhatsAppOnPhone(`${partnerInterestRate}`, advisoryLink, partnerName);
    }
};
export const onCtaTelegram = async (action, _datastore, { instrumentTrack }) => {
    instrumentTrack("REFER_MFD_INITIATED", {
        "type": "Telegram"
    });
    console.warn('**** onCtaTelegram leads Action Triggered ****', action);
    const advisoryLink = action.payload.advisorLink;
    const partnerName = action.payload.partnerName;
    const partnerInterestRate = await SharedPropsService.getFirebaseConfig().partner_interest_rate;
    openAdvisoryLinkTelegram(`${partnerInterestRate}`, advisoryLink, partnerName);
};
export const onCtaCopyLink = async (action, _datastore, { clipboard, setDatastore, instrumentTrack }) => {
    instrumentTrack("REFER_MFD_INITIATED", {
        "type": "copy_link"
    });
    console.warn('**** onCtaCopyLink leads Action Triggered ****', action);
    const advisoryLink = action.payload.advisorLink;
    // const partnerName = action.payload.partnerName;
    await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, 'referMfdAndAdvisorsB3', { label: 'Link Copied' });
    clipboard.set(advisoryLink);
    setTimeout(async () => {
        await setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, 'referMfdAndAdvisorsB3', { label: 'Copy Link' });
    }, 1000);
};
export const onCtaShareLink = async (action, _datastore, standardUtilities) => {
    console.warn('**** onCtaShareLink leads Action Triggered ****', action);
    const advisoryLink = action.payload.advisorLink;
    const partnerName = action.payload.partnerName;
    const partnerInterestRate = await SharedPropsService.getFirebaseConfig().partner_interest_rate;
    onShareAdvisory(`${partnerInterestRate}`, advisoryLink, partnerName);
};
export const onKnowMore = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("INVITE_PARTNER_BANNER_CTA_CLICKED", {
        "page": "referred_partner"
    });
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    openNewTab(`${InviteAndEarnLink}`, OpenNewTabTargetType.blank);
};
export const onFaq = async (action, _datastore, { openNewTab }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    openNewTab('https://voltmoney.in/invite-mfd-terms-and-condition', OpenNewTabTargetType.blank);
};
